import api from '../api';
import {
  CLEAR_RESULTS,
  SHOW_RESULTS,
  UPDATE_SEARCH_TERM
} from '../actions/search';

const SEARCH_GET_SUCCESS = api.events.searchGet.actionSuccess;

const defaultState = {
  searchResults: [],
  searchTerm: '',
  showResults: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case CLEAR_RESULTS:
      return {
        ...state,
        searchResults: []
      };
    case SEARCH_GET_SUCCESS:
      if (action.data.code === 'no_results') {
        return {
          ...state,
          searchResults: []
        };
      }
      return {
        ...state,
        searchResults: action.data
      };
    case SHOW_RESULTS:
      return {
        ...state,
        showResults: action.showResults
      };
    case UPDATE_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.term
      };

    default:
      return state;
  }
};
